<his-dialog-header
    [showCustomButton]="showEditButton && hasEditRights" [customButtonLabel]="'common.edit'"
    [showResetButton]="false"
    [showSaveButton]="false"
    [showBackButton]="showBackButton"
    [showSearchButton]="showSearchButton"
    (customEvent)="edit()">
</his-dialog-header>

<div *ngIf="researchInfrastructure.id" class="layoutBlock detailpage">
    <div class="detailpageSideLeft">
        <div class="circleIconContainer">
            <div class="circle-icon">
                <div><img hisImage="TELESCOPE" class="inlineicon" title="{{'fs.res.researchInfrastructure' | hisUi}}"></div>
            </div>
        </div>
    </div>
    
    <!-- project main data, vcard and details -->
    <div class="detailpageCenter">
        <res-infrastructure-view-vcard
            [researchInfrastructure]="researchInfrastructure">
        </res-infrastructure-view-vcard>

        <res-infrastructure-view-main-data 
        [researchInfrastructure]="researchInfrastructure"
        [operators] = "filteredOperators"
        [coordinators] = "filteredCoordinators"
        ></res-infrastructure-view-main-data>

    </div>

    <!--Platzhalter für leere rechte Spalte-->
    <div class="detailpageSideRight"></div>
</div>
    
<!-- HIS-Listview, wenn Listview gefüllt in patent -->
<ng-container *ngIf="researchInfrastructure.listviews">
    <his-listview [listviewKeys]="['publications']" [listviewData]="researchInfrastructure.listviews"></his-listview>
</ng-container>
